import { render, staticRenderFns } from "./SupportingPhotos.vue?vue&type=template&id=7fedc83c&scoped=true&"
import script from "./SupportingPhotos.vue?vue&type=script&lang=js&"
export * from "./SupportingPhotos.vue?vue&type=script&lang=js&"
import style0 from "./SupportingPhotos.vue?vue&type=style&index=0&id=7fedc83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fedc83c",
  null
  
)

export default component.exports